export function openUrlInNewTab(url: string) {
    const win = window.open(url, "_blank");
    if (win) {
        win.focus();
    }
}

/**
 * @name 判断iOS
 */
export const isiOS = ()=>{
    let u = navigator.userAgent;
     //ios终端\
    return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
}
/**
 * @name 判断android
 */
export const isAndroid = ()=>{
    let u = navigator.userAgent;
     //android终端
    return u.indexOf('Android') > -1 || u.indexOf('Adr') > -1
}

export function isRunInWeChat() {
    let ua = navigator.userAgent.toLowerCase();
    return ua.indexOf('micromessenger') != -1;
}
